import { forwardRef } from 'react'
import { useIntl } from 'react-intl'
import Heading from 'LuxKit/Typography/Heading'
import SmallToggleButton from 'LuxKit/Button/SmallToggleButton'
import styled from 'styled-components'

const HeadingWrapper = styled.div`
  display: flex;
  justify-content: space-between;
`

interface Props {
  disableExpand?: boolean
  expandDirection: 'up' | 'down'
  minimised: boolean
  onToggleMinimise: () => void
  title?: string
}

const YouMayAlsoLikeHeader = forwardRef<HTMLDivElement, Props>((props, ref) => {
  const { onToggleMinimise, expandDirection, minimised, disableExpand, title } = props
  const intl = useIntl()
  const toggledOn = expandDirection === 'up' ? minimised : !minimised
  const headingTitle = title || intl.formatMessage({
    id: 'jLdhLZL9MF9YVol42hoE',
    defaultMessage: 'Exclusive hotel offers you may also like',
  })
  const showLabel = intl.formatMessage({
    id: 'f67910D4xDjQYsBBoVXC',
    defaultMessage: 'Show',
  })
  const hideLabel = intl.formatMessage({
    id: '394T7tMtLp_FpY3tJnWa',
    defaultMessage: 'Hide',
  })
  return (
    <HeadingWrapper ref={ref}>
      <Heading variant="heading6">{headingTitle}</Heading>
      {!disableExpand && <SmallToggleButton on={toggledOn} onClick={onToggleMinimise} iconPosition="start">
        {minimised ? showLabel : hideLabel}
      </SmallToggleButton>}
    </HeadingWrapper>
  )
})

export default YouMayAlsoLikeHeader
